import React from 'react';
//Component
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';

export const CollapsibleTable = props => {
  const { header, body, footer } = props;
  return (
    <TableContainer component={Paper}>
      <Table aria-label='collapsible table'>
        <TableHead>
          <TableRow>
            <TableCell />
            {header}
          </TableRow>
        </TableHead>
        <TableBody>{body}</TableBody>
      </Table>
      {footer}
    </TableContainer>
  );
};
